import { typeState } from './types';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import bgImgOne from '../../assets/images/game/bg/01.png';
import bgImgTwo from '../../assets/images/game/bg/02.png';
import bgImgThree from '../../assets/images/game/bg/03.png';
import bgImgFor from '../../assets/images/game/bg/04.png';
import bgImgFive from '../../assets/images/game/bg/05.png';
import bgImgSix from '../../assets/images/game/bg/06.png';
import bgImgSeven from '../../assets/images/game/bg/07.png';

const bgImages = [bgImgOne, bgImgThree, bgImgFor, bgImgFive, bgImgSeven];

const initialState: typeState = {
  bgId: 0,
  bgImage: bgImgOne,
  isNextLocation: true,
  count: 0,
  charge: 100,
};

export const game = createSlice({
  name: 'game',
  initialState,
  reducers: {
    nextLocation(state) {
      state.bgImage = bgImages[state.bgId + 1];
      state.bgId = state.bgId + 1;
    },
    setIsNextlocation(state, action: PayloadAction<boolean>) {
      state.isNextLocation = action.payload;
    },
    againGame(state) {
      state.bgImage = bgImgOne;
      state.bgId = 0;
      state.count = 0;
    },
    incrementCount(state) {
      state.count = state.count + 1;
    },

    decreaseCharge(state) {
      if (state.charge - 12 > 0) {
        state.charge = state.charge - 12;
      } else {
        state.charge = 0;
      }
    },
    replishCharge(state) {
      if (state.charge + 9 < 100) {
        state.charge = state.charge + 9;
      } else {
        state.charge = 100;
      }
    },
    setCharge(state, action: PayloadAction<number>) {
      state.charge = action.payload;
    },
  },
});

export const {
  nextLocation,
  incrementCount,
  decreaseCharge,
  replishCharge,
  setCharge,
  againGame,
  setIsNextlocation,
} = game.actions;

export default game.reducer;
